import { Component, OnInit } from '@angular/core';
import { AlertListService, QueryStringService } from '@xref/ngx';

import { OauthService } from '../../services/oauth/oauth.service';

export class OauthLinkedIn {
    hiringContext = '';
    extensionType = '';
    redirectUrl = '';

    constructor() {}
}

@Component({
    selector: 'xlog-oauth-linkedin',
    templateUrl: './oauth-linkedin.component.pug',
    styleUrls: ['./oauth-linkedin.component.scss'],
    standalone: false
})
export class OauthLinkedInComponent implements OnInit {

    loading = false;
    error = false;

    oauthLinkedIn = new OauthLinkedIn();
    signature: string;

    constructor(
        private oauth: OauthService,
        private qString: QueryStringService,
        private alertList: AlertListService
    ) {}

    ngOnInit() {
        this.getQueryParams();
    }

    connectLinkedIn() {
        this.alertList.clear(true);
        this.loading = true;
        this.error = false;

        this.oauth
            .connectLinkedIn(this.oauthLinkedIn, this.signature)
            .subscribe(
                this.linkedInConnectSuccess,
                this.linkedInConnectFailed
            );
    }

    cancel() {
        this.oauth.redirect(this.oauthLinkedIn.redirectUrl);
    }

    private linkedInConnectSuccess = () => {
    // this.loading = false; # the loading spinner can keep displaying till user is redirected.
        this.oauth.redirect(this.oauthLinkedIn.redirectUrl);
    };

    private linkedInConnectFailed = (error: any) => {
        this.loading = false;
        this.error = true;

        switch (error.status) {
            case 400:
                this.alertList.append([{
                    messageKey: 'oauth.linkedIn.alerts.clientError',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
            case 401:
                this.alertList.append([{
                    messageKey: 'oauth.linkedIn.alerts.authError',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
            case 403:
                this.alertList.append([{
                    messageKey: 'oauth.linkedIn.alerts.permissionError',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
            default:
                this.alertList.append([{
                    messageKey: 'alerts.generic.error',
                    type: 'danger',
                    timeout: 0
                }]);
                break;
        }
    };

    private getQueryParams() {
        this.oauthLinkedIn.extensionType = decodeURIComponent(this.qString.getParam('extensionType'));
        this.oauthLinkedIn.hiringContext = decodeURIComponent(this.qString.getParam('hiringContext'));
        this.oauthLinkedIn.redirectUrl = decodeURIComponent(this.qString.getParam('redirectUrl'));
        this.signature = decodeURIComponent(this.qString.getParam('signature'));
    }
}
